// Satori-safe hex/rgb mirror of the OKLCh palette in
// `src/app/globals.css`. Satori (the renderer behind `next/og`) doesn't
// understand OKLCh, so OG components must reference these constants
// instead of the CSS tokens.
//
// Source values come from the trailing `/* #hex */` comment on each
// `--color-*` declaration in globals.css. When that file changes,
// update these in lockstep.

export const OG_TOKENS = {
  // Brand scale
  brand50: '#f0f2fe',
  brand100: '#dbe0fd',
  brand200: '#bbc6fc',
  brand300: '#95a4fa',
  brand400: '#6e7ff7',
  brand500: '#4f5cf5',
  brand600: '#313cf3',
  brand700: '#0d20f2', // core
  brand800: '#0a1ac2',
  brand900: '#08159b',
  brand950: '#0b0f44',
  brandX: '#1da1f2',

  // Gray scale
  gray50: '#fafafa',
  gray100: '#efefef',
  gray200: '#e3e3e3',
  gray300: '#cccccc',
  gray400: '#a8a8a8',
  gray500: '#777777',
  gray600: '#4a4a4a',
  gray700: '#2f2f2f',
  gray800: '#1f1f1f',
  gray900: '#191919',
  gray950: '#111111',

  // Semantic
  success500: '#10b981',
  success600: '#059669',
  danger500: '#ef4444',
  danger600: '#dc2626',
  warning500: '#f59e0b',
} as const;

export const OG_DIMENSIONS = {
  width: 1200,
  height: 630,
} as const;

/** Standard shell inset (px) for data/default/gift variants — matches
 *  `SHELL_METRICS.*.inset` for those variants. */
export const OG_SHELL_INSET_PX = 64;

/** Full-bleed row width inside a 64px-inset shell (1200 − 128).
 *  Celebration/mono shells use 56px inset → 1088px; use
 *  `getShellContentWidth()` from shell-tokens when layout depends on variant.
 *  Feed thumbnail crop uses 1080×540 (`OG_FEED_CROP_RATIO`) — not layout width. */
export const OG_CONTENT_WIDTH: number = OG_DIMENSIONS.width - OG_SHELL_INSET_PX * 2;

export type OgToken = keyof typeof OG_TOKENS;
